import React, { Component } from 'react'
import style from './UserIndexView.scss'

import settingicon from '../../../../assets/settingicon.png'
import qricon from '../../../../assets/qricon.png'
import {api} from '../../../../common/app'
import {Ribbon} from "./ribbon/ribbon";
import {Button, List, Modal, Toast, Result, Icon} from "antd-mobile";
import {MultiTouch} from "../../../../components/electronic-seal/multi-touch";
import defaultImg from "../../../../assets/chapter_default.png";
import ReactSwipe from 'react-swipe';

const Item = List.Item;

export class UserIndexView extends Component {
constructor(props) {
  super(props);
  this.state = {
    meetingid:null,

    username:null,
    userqr:null,
    meetingname:null,
    usercode:null,
    paystatus:null,
      modalVisible : false,
      place_name : []
  };
     this.refreshProps = this.refreshProps.bind(this);
     this.getUserInfo = this.getUserInfo.bind(this);
}
componentWillReceiveProps(nextprops) {
  this.refreshProps(nextprops);
}
componentDidMount() {
    if(this.props.match.params.meetingid == 475){
        this.setState({meetingid:475})
    }else{
        this.refreshProps(this.props);
    }
}
refreshProps(props) {
    let params = props.match.params;
    if (this.state.meetingid != params.id) {
      this.state.meetingid = params.id;
      this.setState(this.state);
      this.getUserInfo(params.id);
    }
}
getUserInfo(meetingid){
    api.getUserInfoIndex(meetingid).then(res=>{
        if (res.code === 200) {
            this.state.username = res.result.username;
            this.state.meetingname = res.result.title;
            this.state.usercode = res.result.str;
            this.state.paystatus = res.result.is_pay;
            this.state.userqr = res.result.erweima;
            this.state.place_name = res.result.place_name
            this.setState(this.state);
        }else{
            if (res.code === 40001) {
                window.location.hash = '#/home/index/'+meetingid;
                alert(res.message);
            }
        }
    },err=>{
        console.log(err);

    })
}
render() {
  return (
      this.state.meetingid == 475 ? <div style={{zIndex:999,position:"absolute",top:0,left:0,width:"100%"}}>
              <img style={{width:"100%"}} src={"https://file-test.huibaifen.com/huibaifen-file/pay-info.jpg"} />
          </div> :
    <div className={style.UserIndexView}>
        <div className={[style.HnadleGroup,'childcenter'].join(' ')}>
            <div className={[style.ColumnBox,'childcenter childcontentstart'].join(' ')}>
                <div className={style.SettingBox} onClick={()=>{window.location.hash = '#/home/setting/'+this.state.meetingid}}>
                    <img src={settingicon} alt=""/>
                </div>
            </div>
            <div className={[style.ColumnBox,'childcenter childcontentend'].join(' ')}>
                {
                this.state.paystatus === 1 ?
                    <div className={[style.PayStatusButton,'childcenter'].join(' ')}>已缴费</div>:
                this.state.paystatus === 2 ?
                    <div className={[style.PayStatusButton,'childcenter'].join(' ')} onClick={(()=>{window.location.hash='#/home/pay/'+this.state.meetingid}).bind(this)}>未缴费</div>
                    :
                    undefined
                }
            </div>
        </div>
        <div className={style.content}>
            <Ribbon>
                <div>
                    <div className={style.chapter}>
                        <Button style={{color : "#fff", background:"#A06300"}} size={"small"} onClick={()=>{
                            this.setState({modalVisible : true})
                        }}>电子章签到</Button>
                    </div>
                    <div className={style.QR}>
                        <div className={style.title}>{this.state.meetingname==null?'':this.state.meetingname}</div>
                        <div className={style.QRBox}>
                            {
                                this.state.paystatus === 2 ?
                                    <div className={[style.Tips].join(' ')} onClick={(()=>{window.location.hash='#/home/pay/'+this.state.meetingid}).bind(this)}>
                                        您尚未缴费,去缴费
                                    </div>
                                    :
                                    <>
                                        <div className={style.UserName}>
                                            {this.state.username==null?'':this.state.username}
                                        </div>
                                        <div className={style.UserQRCode}>
                                            <img src={this.state.userqr==null?'':this.state.userqr} alt=""/>
                                        </div>
                                        <div className={style.UserCode}>
                                            识别码:{this.state.usercode==null?'':this.state.usercode}
                                        </div>
                                    </>
                            }
                        </div>
                        <div className={style.Tips}>
                            向主办方出示该二维码用于会中服务
                        </div>
                    </div>
                </div>
            </Ribbon>
        </div>



        <Modal visible={this.state.modalVisible} transparent={true} maskClosable={true} onClose={()=>{this.setState({modalVisible : false})}} style={{width: "92%"}}>
            <div style={{color : "#A06300", fontSize : 18, margin : "10px 0px"}}>电子签章处</div>

                <div style={{border : "1px dashed #ccc", height : "80vw", overflow: "scroll"}}>
                    {
                        this.state.place_name?.length > 0 ?
                            <ReactSwipe swipeOptions={{continuous : true}}>
                                {
                                    this.state.place_name?.map(value =>
                                        <MultiTouch minTrigger={5} onTrigger={touches => {
                                            api.setUserCheckIn(this.props.match.params.id, value.id, this.state.usercode).then(res => {
                                                this.getUserInfo(this.props.match.params.id);
                                                Toast.success("签到成功")
                                            }).catch(e => {
                                                Toast.success("签到失败 "+ e.message)
                                            })
                                            // Toast.info(JSON.stringify(touches.map(value => ({x : value.pageX, y : value.pageY}))),undefined, undefined, false)
                                            // Toast.info(value.id + "签到",undefined, undefined, false)
                                        }}>
                                            <div style={{height : "80vw", position : "relative" , display : "flex", flexDirection : "column", justifyContent: "center", alignItems: "center"}}>
                                                {
                                                    value.status === 1 ?
                                                        <div>
                                                            <Icon type="check-circle" style={{ fill: 'green', width: 60, height: 60, border: "none" }} />
                                                            <div>已签到</div>
                                                        </div>
                                                        :
                                                        undefined
                                                }
                                                <div style={{fontSize : 18}}>
                                                    {value.title}
                                                </div>
                                            </div>
                                        </MultiTouch>
                                    )
                                }
                            </ReactSwipe>
                            :
                            <div style={{height : "80vw" , display : "flex", flexDirection : "column", justifyContent: "center", alignItems: "center"}}>
                                <div>暂无会场</div>
                            </div>
                    }
                </div>
            <div style={{color : "#A06300", fontSize : 12, margin : "5px 0px"}}>
                请在虚线内盖章
            </div>
        </Modal>
    </div>
   )
   }
}
export default UserIndexView
